import { screenRegistry, type ScreenMeta, type ShellKind } from "@/app/screenRegistry";

/**
 * Implemented-screen allowlist for **emergency** legacy nav (`VITE_NAV_SOURCE=legacy`).
 * Production Ops IA order/labels come from BE nav catalog (FRS-SYS-06 · W5).
 */
export function menusForShell(shell: ShellKind): ScreenMeta[] {
  const implemented = new Set([
    "SCR-OPS-HOME",
    "SCR-BI-PROD",
    "SCR-BI-QC",
    "SCR-BI-WH",
    "SCR-FIELD-HOME",
    "SCR-MES-TODAY",
    "SCR-MES-SCAN",
    "SCR-MES-CIP",
    "SCR-MES-HANDOVER",
    "SCR-EXE-HOME",
    "SCR-EXE-APPROVALS",
    "SCR-EXE-ALERTS",
    "SCR-EXE-REPORTS",
    "SCR-MDM-ITEM",
    "SCR-MDM-ITEM-CATEGORY",
    "SCR-MDM-UOM",
    "SCR-MDM-WH",
    "SCR-MDM-LOC",
    "SCR-MDM-EQUIP",
    "SCR-MDM-EQUIP-TYPE",
    "SCR-MDM-DEFECT",
    "SCR-MDM-REASON",
    "SCR-MDM-LOSS-TYPE",
    "SCR-SAL-CUSTOMER",
    "SCR-SAL-SO",
    "SCR-PUR-SUPPLIER",
    "SCR-PUR-PR",
    "SCR-PUR-PO",
    "SCR-PLN-DEMAND",
    "SCR-PLN-ORDER",
    "SCR-PLN-RESERVE",
    "SCR-MES-BATCH",
    "SCR-MES-ISSUE",
    "SCR-MES-HOLD",
    "SCR-MES-LOSS-LEDGER",
    "SCR-ENG-PRODUCT-TYPE",
    "SCR-ENG-PRODUCT",
    "SCR-ENG-TECHNICAL-INFO",
    "SCR-ENG-SPEC",
    "SCR-ENG-QCPLAN",
    "SCR-ENG-RELEASE",
    "SCR-ENG-OP-TEMPLATE",
    "SCR-ENG-PACK-FORMAT",
    "SCR-ENG-ONBOARD",
    "SCR-SYS-LINE",
    "SCR-SYS-AREA",

    "SCR-UI-GALLERY",
    "SCR-SYS-ORG",
    "SCR-SYS-ORG-UNIT",
    "SCR-SYS-USER",
    "SCR-SYS-ROLE",
    "SCR-SYS-AUDIT",
    "SCR-SYS-SHIFT",
    "SCR-SYS-MOBILE-APP",
    "SCR-SYS-CATEGORY",
    "SCR-INT-EMAIL-LOG",
    "SCR-SYS-CONFIG-HUB",
    "SCR-SYS-NOTIFY-CATALOG",
    "SCR-SYS-NAV-MENU",
    "SCR-SYS-MFA",
    "SCR-SYS-NUMBERING",
    "SCR-SYS-DEFAULTS",
    "SCR-SYS-NOTIFICATIONS",
    "SCR-SYS-NOTIFY-PREF",
    "SCR-SYS-NOTIFICATIONS",
    "SCR-SYS-APPROVALS",
    "SCR-SYS-APPROVAL-POLICIES",
    "SCR-WMS-GR",
    "SCR-WMS-GI",
    "SCR-WMS-MOVE",
    "SCR-WMS-STOCK",
    "SCR-WMS-EXPIRY",
    "SCR-WMS-COUNT",
    "SCR-WMS-DISPOSAL",
    "SCR-QMS-IQC",
    "SCR-QMS-NCR",
    "SCR-QMS-RELEASE",
    "SCR-QMS-FQC",
    "SCR-QMS-DEVIATION",
    "SCR-TRC-SEARCH",
    "SCR-TRC-TREE",
    "SCR-DOC-MASTER",
    "SCR-DOC-FORM-INST-OPS",
    "SCR-DOC-SAVED",
  ]);

  return screenRegistry.filter((s) => {
    if (s.shell !== shell || !s.menuGroup) return false;
    if (!implemented.has(s.screenId)) return false;
    if (s.screenId === "SCR-UI-GALLERY" && !import.meta.env.DEV) return false;
    return true;
  });
}
